import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Row, Grid, Column } from '../Grid';
import {
  footer,
  grid,
  nav,
  listItem,
  logo,
  content,
} from './Footer.module.scss';

const Footer = ({ Content, links, Logo }) => {
  const { firstCol, secondCol } = links;
  const { site } = useStaticQuery(graphql`
    query BUILD_TIME_QUERY {
      site {
        buildTime(formatString: "DD MM YYYY")
      }
    }
  `);
  return (
    <footer className={footer}>
      <Grid className={grid}>
        <Row>
          <Column colLg={2} colMd={2}>
            <ul className={nav}>
              {firstCol &&
                firstCol.map((link, i) => (
                  <li key={i} className={listItem}>
                    <a href={link.href} aria-label={link.linkText}>
                      {link.linkText}
                    </a>
                  </li>
                ))}
            </ul>
          </Column>
          <Column colLg={2} colMd={2}>
            <ul className={nav}>
              {secondCol &&
                secondCol.map((link, i) => (
                  <li key={i} className={listItem}>
                    <a href={link.href} aria-label={link.linkText}>
                      {link.linkText}
                    </a>
                  </li>
                ))}
            </ul>
          </Column>
          <Column
            className={content}
            colLg={4}
            colMd={4}
            colSm={3}
            offsetLg={2}>
            <Content buildTime={site.buildTime} />
          </Column>
        </Row>
        <Row>
          <Column colLg={3}>
            <Logo />
          </Column>
        </Row>
      </Grid>
    </footer>
  );
};

const IBMLogo = () => (
    <svg className={logo} width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
      <path
        d="M 69.485643,61.642234 C 56.41358,61.039707 45.132407,50.451646 42.614921,37.797092 39.558526,24.762789 45.640459,9.9278782 57.525025,3.5044707 c 9.647426,-5.5347402 22.505855,-4.41764994 31.077192,2.6721097 5.910939,4.6726186 9.844255,11.6172866 11.186175,19.0003156 -5.672759,0 -11.34552,0 -17.01828,0 -2.514829,-6.222888 -10.301825,-9.816989 -16.507309,-6.945966 -7.871606,3.182801 -10.546678,14.100875 -5.469183,20.770841 3.758698,5.647659 12.280081,7.283394 17.640053,2.937245 3.177366,-0.918976 2.817852,-6.557299 6.188175,-6.006293 5.082268,-2.41e-4 10.164534,-4.87e-4 15.2468,-7.32e-4 -1.771757,12.120725 -11.327885,23.007793 -23.521978,25.228505 -2.256479,0.443604 -4.567842,0.535466 -6.861027,0.481738 z m -56.25304,-0.50221 c 7.554862,-1.198781 11.608079,-9.219027 11.648541,-16.259623 0.214952,-5.987876 -2.075873,-12.929682 -7.99731,-15.447314 4.11443,-2.574619 5.384133,-7.854074 5.926092,-12.385741 C 23.146451,12.452295 22.128228,7.3933086 18.413955,4.3185581 17.496597,2.8251703 12.452664,1.6646832 12.729849,1.4440632 c 9.666937,-0.00315 19.333873,-0.0063 29.000808,-0.00943 -3.871516,9.4669478 -7.766667,18.9243278 -11.649595,28.3866488 3.9503,10.492122 7.903274,20.983243 11.851173,31.476265 -9.822833,-0.0066 -19.645666,-0.01281 -29.468502,-0.01932 0.255543,-0.04523 0.515174,-0.09507 0.76887,-0.1382 z M 0.13599297,42.366602 c 0,-1.913742 0,-3.827486 0,-5.741228 2.70081723,0.160879 5.49023413,-0.210833 8.13221543,0.303729 4.7657116,1.399866 4.9959686,9.331513 0.254039,10.837203 -2.7188897,0.703491 -5.5985719,0.172956 -8.38637066,0.340462 3.875e-5,-1.91339 7.749e-5,-3.826777 1.1623e-4,-5.740166 z M 69.928984,38.874244 c -5.59459,-0.80787 -8.405633,-8.048934 -5.231976,-12.570793 2.400184,-4.248811 8.860793,-4.82755 11.964708,-1.070102 3.627182,3.849122 2.3517,10.822333 -2.476426,13.02618 -1.31579,0.627958 -2.820609,0.766918 -4.256306,0.614715 z M 2.9008469,24.897757 c -1.4555985,-0.02835 -3.44015386,0.466798 -2.76485393,-1.670391 0,-3.239635 0,-6.47927 0,-9.718905 2.81792403,0.242195 5.86210183,-0.626274 8.46811353,0.760992 3.0302195,2.396589 3.1621125,8.131878 -0.3689127,10.100054 -1.6598031,0.890335 -3.5464253,0.474648 -5.3343469,0.52825 z" fill="#ffffff"
        />
      </g>
    </svg>

);

const DefaultContent = () => (
  <p>
    Shadow this content by importing the theme Footer and supplying your own
    props.
  </p>
);

Footer.defaultProps = {
  links: {
    firstCol: [
      { href: 'https://www.ibm.com/design', linkText: 'Sample' },
      { href: 'https://www.ibm.com/design', linkText: 'Links' },
      {
        href: 'https://www.ibm.com/design',
        linkText: 'Column',
      },
      { href: 'https://www.ibm.com/design', linkText: 'One' },
    ],
    secondCol: [
      {
        href: 'https://www.ibm.com/design',
        linkText: 'Dribbble',
      },
      {
        href: 'https://www.ibm.com/design',
        linkText: 'Medium',
      },
      {
        href: 'https://www.ibm.com/design',
        linkText: 'Twitter',
      },
    ],
  },
  Content: DefaultContent,
  Logo: IBMLogo,
};

Footer.propTypes = {
  /**
   * Specify the first and second columns of your links
   */
  links: PropTypes.exact({
    firstCol: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        linkText: PropTypes.string,
      })
    ),
    secondCol: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        linkText: PropTypes.string,
      })
    ),
  }),

  /**
   * Specify the first and second columns of your links
   */
  Content: PropTypes.elementType,

  /**
   * Provide a logo to be rendered in the bottom left corner
   */
  Logo: PropTypes.elementType,
};

export default Footer;
